import en from '../contribution-unit/en.json'
import es from '../contribution-unit/es.json'
import fr from '../contribution-unit/fr.json'
import ko from '../contribution-unit/ko.json'
import de from '../contribution-unit/de.json'
import pt from '../contribution-unit/pt.json'
import it from '../contribution-unit/it.json'
import pl from '../contribution-unit/pl.json'
import zh from '../contribution-unit/zh.json'
import { i18n } from 'next-i18next'

const contributionUnits = { en, es, fr, ko, de, pt, it, pl, zh }

export const loadContributionUnitsArray = (): string[] => {
  const { singular: data } = contributionUnits[i18n.language]
  return data
}

export const loadDefaultContributionUnit = (contribution_unit: string, locale = 'en') => {
  if (locale === 'en') { return contribution_unit }
  const { singular: dataInEnglish } = contributionUnits['en']
  const { singular: singularData } = contributionUnits[locale]
  return dataInEnglish[singularData.indexOf(contribution_unit)]
}

export const getContributionUnitInUserLanguage = (contribution_unit: string, locale = 'en', amount = null) => {
  if (locale === 'en' && amount === null) { return contribution_unit }
  const { singular: dataInEnglish } = contributionUnits['en']
  const { plural: pluralData } = contributionUnits[locale]
  if (amount !== null && amount > 1) {
    return pluralData[dataInEnglish.indexOf(contribution_unit)]
  }
  const { singular: singularData } = contributionUnits[locale]
  return singularData[dataInEnglish.indexOf(contribution_unit)]
}
